import { Navigate } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface text-ink">
        <div className="rounded-3xl border border-slate-200 bg-white/90 px-6 py-4 text-sm text-slate-500">
          Checking session...
        </div>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute
